import { mount } from '../../../js/dom-lifecycle';

mount('[data-required-value]', el => {
    const buttons = el.form.querySelectorAll('[type="submit"]');
    const update = () => buttons.forEach(button => button.disabled = el.value != el.dataset.requiredValue);
    el.addEventListener('input', update);
    update();
});
